"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WmsLayerGroupFactory = void 0;
var WmsLayerGroup_1 = require("./WmsLayerGroup");
var WmsLayer_1 = require("../../wms/WmsLayer");
var FilterType_1 = require("../../../map/filters/FilterType");
var WmsLayerGroupFactory = /** @class */ (function () {
    function WmsLayerGroupFactory() {
        var _this = this;
        this.getLayerGroups = function (layerConfig) {
            var layerGroups = new Array();
            for (var _i = 0, layerConfig_1 = layerConfig; _i < layerConfig_1.length; _i++) {
                var layer = layerConfig_1[_i];
                layerGroups.push(_this.getLayerGroup(layer));
            }
            return layerGroups;
        };
    }
    WmsLayerGroupFactory.prototype.getLayerGroup = function (layerConfig) {
        var url = layerConfig.url;
        var ref = layerConfig.ref || (layerConfig.type.toString() + ((layerConfig.subType) ? ("_" + layerConfig.subType.toString()) : ""));
        var lg = new WmsLayerGroup_1.WmsLayerGroup(layerConfig.type, layerConfig.subType, layerConfig.displayName, ref, url);
        if (layerConfig.urlParams) {
            lg.urlParams = layerConfig.urlParams;
        }
        lg.queryable = true;
        lg.filterOptions = layerConfig.filterOptions || { filterType: FilterType_1.FilterType.NotSet, filters: [] };
        if (typeof layerConfig.queryable != "undefined" && layerConfig.queryable === false) {
            lg.queryable = false;
        }
        if (typeof layerConfig.info_format != "undefined") {
            lg.info_format = layerConfig.info_format;
        }
        if (typeof layerConfig.info_columns_to_show != "undefined") {
            lg.info_columns_to_show = layerConfig.info_columns_to_show;
        }
        if (layerConfig.filterOptions != null) {
            //merge the two
            lg.filterOptions = __assign(__assign({}, lg.filterOptions), layerConfig.filterOptions);
        }
        if (layerConfig.displayInLayerSwitcher === false) {
            lg.displayInLayerSwitcher = false;
        }
        if (typeof layerConfig.displayInLegend != "undefined") {
            lg.displayInLegend = layerConfig.displayInLegend;
        }
        if (layerConfig.visibleOnFirstLoad === false) {
            lg.visibleOnFirstLoad = false;
        }
        if (layerConfig.visibleOnLoad === true) {
            lg.visibleOnLoad = true;
        }
        if (typeof layerConfig.layers !== "undefined" && layerConfig.layers !== null) {
            for (var _i = 0, _a = layerConfig.layers; _i < _a.length; _i++) {
                var t1 = _a[_i];
                lg.layers.push(new WmsLayer_1.WmsLayer(lg, t1.minZoom, t1.maxZoom, t1.layerName, lg.queryable, t1.styleName, lg.urlParams));
            }
        }
        return lg;
    };
    return WmsLayerGroupFactory;
}());
exports.WmsLayerGroupFactory = WmsLayerGroupFactory;
//# sourceMappingURL=WmsLayerGroupFactory.js.map